module.exports = __webpack_public_path__ + "img/tipsIcon.070182e8.svg";